// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2168":"50cd997e","5833":"a7f8a8f3","6000":"239f879c","8615":"239f879c"}[chunkId] + ".chunk.css";
};